
<script>
import { ShoppingCart, Account } from './../../functions.js'

import QuickviewModal from './QuickviewModal.vue'
import AddToCartModal from './AddToCartModal.vue'
import WishlistModal from './WishlistModal.vue'

import AccountAPI from './../../api/account.js';

export default {
  name: 'ProductCard',
   components: {
    QuickviewModal,
    AddToCartModal,
    WishlistModal,
  },
  data () {
    return {
      Account,
      ShoppingCart,
      showQuickview: false,
      showAddToCart: false,
      showAddToWishlist: false,
      modal_status: "success",
      modal_custom_message: "",
    }
  },
   props: {
      product: {
      type: Object,
        default: {}
      }
  },
  mounted () {
   
  },
   methods: {
    async addToCart (product, quantity) {

        this.ShoppingCart.addToCart(product, quantity).then((response)=>{
        this.modal_status = (response.status == 'success' ? 'success' : 'failed');
        this.modal_custom_message = (response.status == 'success' ? '' : response.message);
        // this.showAddToCart = true;
         var add_cart = this.$parent.$refs.addToCartDialogue.show({
              product: product,
              status: this.modal_status,
              message: this.modal_custom_message,
              // okButton: 'Back to Home',
         
          });
        });
     
    },
    addToWishlist (product, quantity) {
    
        this.ShoppingCart.addToWishlist(product, quantity);
        this.showAddToWishlist = true;
      
    },
   async quickview (product) {
        // this.showQuickview = true;
        var quickview = await this.$parent.$refs.quickviewDialogue.show({
              product: product,
              status: this.modal_status,
              message: this.modal_custom_message,
              // okButton: 'Back to Home',
          });

          if(quickview)
          {
            this.addToCart(quickview.product, quickview.quantity);
          }

    },
    quickviewAddToCart(data)
    {
      this.addToCart(data.product, data.quantity);
    },
    quickvieWishlist(data)
    {
      this.addToWishlist(data.product, data.quantity);
    },
    convertToSlug (string) {
      return (string.replace(/\s/g, '-')).toLowerCase()
    },
    viewProduct(product)
    {
      this.$router.push({ name: 'productDetails', params: { sku_id: product.sku, sku_name: this.convertToSlug(product.product_name) }});
    },
    getProductPrice(product)
    {
      if(product.sale_type == 'default')
      {
        return (product.product_price);
      }
      else
      {
       
          var has_price_off_promo = false;
          var price_off_promo_index = 0;
          if(product.promo) {
            product.promo.forEach((promo, promo_index)=>{
              if(typeof promo == 'object' && !Array.isArray(promo))
              {
                if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                {
                  price_off_promo_index = promo_index;
                  has_price_off_promo = true;
                }
              }
            });
          }
          
          if(has_price_off_promo)
          {
            var passed_product_requirements = 0;
            product.promo[price_off_promo_index].required_items.forEach((ri,ri_index)=>{
              ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                if(p.product.sku == ri.sku_id)
                {
                  passed_product_requirements+=1;
                }
              });
            });

            if(passed_product_requirements == product.promo[price_off_promo_index].required_items.length)
            {

               if(product.promo[price_off_promo_index].promo_minimum_amount)
                {
                  return (product.product_price == parseFloat(product.product_sale_price) ? product.product_price : product.product_sale_price);
                }
                else
                {
                   return (product.sale_price);
                }
            }
            else
            {
               return (product.product_price == parseFloat(product.product_sale_price) ? product.product_price : product.product_sale_price);
            }

          }
          else
          {
               return (product.product_price == parseFloat(product.product_sale_price) ? product.product_price : product.product_sale_price);
          }

       

      }
     

      // if(product.sale_type == 'fixed' || product.sale_type == 'percentage' || product.sale_type == 'promo')
      // {
      //   if(product.sale_type == 'promo')
      //   {

      //     var has_price_off_promo = false;
      //     var price_off_promo_index = 0;
      //     product.promo.forEach((promo, promo_index)=>{
      //       if(typeof promo == 'object' && !Array.isArray(promo))
      //       {
      //         if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
      //         {
      //           price_off_promo_index = promo_index;
      //           has_price_off_promo = true;
      //         }
      //       }
      //     });
          
      //     if(has_price_off_promo)
      //     {
      //       var passed_product_requirements = 0;
      //       product.promo[price_off_promo_index].required_items.forEach((ri,ri_index)=>{
      //         ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
      //           if(p.product.sku == ri.sku_id)
      //           {
      //             passed_product_requirements+=1;
      //           }
      //         });
      //       });

      //       if(passed_product_requirements == product.promo[price_off_promo_index].required_items.length)
      //       {

      //          if(product.promo[price_off_promo_index].promo_minimum_amount)
      //           {

      //             return (product.product_price);
      //           }
      //           else
      //           {

      //             return  (product.sale_price );
      //           }
      //       }
      //       else
      //       {

      //         return  (product.product_price);
      //       }

      //     }
      //     else
      //     {

      //         return (product.product_price);
      //     }

      //   }
      //   else
      //   {
      //     return (product.sale_price);
      //   }

      // }
      // else
      // {
      //   return (product.product_price);
      // }

    },
    hasProductPromo(product)
    {

      if(product.promo && product.promo.length)
      {
         return true;
      }
      else
      {
        return null;
      }

    },
    getProductSlashedPrice(product)
    {

      if(product.sale_type == 'default')
      {
        return 0;
      }
      else
      {
          var has_price_off_promo = false;
          var price_off_promo_index = 0;
          if(product.promo) {
            product.promo.forEach((promo, promo_index)=>{
              if(typeof promo == 'object' && !Array.isArray(promo)){
                if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
                {
                  price_off_promo_index = promo_index;
                  has_price_off_promo = true;
                }
              }
            });
          }


          if(has_price_off_promo)
          {
              var passed_product_requirements = 0;
              product.promo[price_off_promo_index].required_items.forEach((ri,ri_index)=>{
                ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
                  if(p.product.sku == ri.sku_id)
                  {
                    passed_product_requirements+=1;
                  }
                });
              });

              if(passed_product_requirements == product.promo[price_off_promo_index].required_items.length)
              {
                  if(product.promo[price_off_promo_index].promo_minimum_amount)
                  {
                    return (product.product_price == parseFloat(product.product_sale_price) ? 0 : product.original_price);
                  }
                  else
                  {
                    return (product.original_price);
                  }
                 
              }
              else
              {
                return (product.product_price == parseFloat(product.product_sale_price) ? 0 : product.original_price);
              }
         

          }
          else
          {
           return (product.product_price == parseFloat(product.product_sale_price) ? 0 : product.original_price);
          }

        }

    


      // if(product.sale_type == 'fixed' || product.sale_type == 'percentage' || product.sale_type == 'promo')
      // {
      //   if(product.sale_type == 'promo')
      //   {

      //     var has_price_off_promo = false;
      //     var price_off_promo_index = 0;
      //     product.promo.forEach((promo, promo_index)=>{
      //       if(typeof promo == 'object' && !Array.isArray(promo)){
      //         if( (promo.promo_type).toUpperCase() == 'PRICE DISCOUNT')
      //         {
      //           price_off_promo_index = promo_index;
      //           has_price_off_promo = true;
      //         }
      //       }
      //     });


      //     if(has_price_off_promo)
      //     {
      //         var passed_product_requirements = 0;
      //         product.promo[price_off_promo_index].required_items.forEach((ri,ri_index)=>{
      //           ShoppingCart.cart[ShoppingCart.active_shopping_cart].products.forEach((p,p_index)=>{
      //             if(p.product.sku == ri.sku_id)
      //             {
      //               passed_product_requirements+=1;
      //             }
      //           });
      //         });

      //         if(passed_product_requirements == product.promo[price_off_promo_index].required_items.length)
      //         {
      //             if(product.promo[price_off_promo_index].promo_minimum_amount)
      //             {
      //               return  0;
      //             }
      //             else
      //             {
      //               return  (product.original_price);
      //             }
                 
      //         }
      //         else
      //         {
      //           return  (0);
      //         }
         

      //     }
      //     else
      //     {
      //       return (0);
      //     }

      //   }
      //   else
      //   {
      //     return (product.original_price);
      //   }

      // }
      // else
      // {
      //   return (0);
      // }
    }
  }
}
</script>
<template>
    <div>
    <div class="ltn__product-item ltn__product-item-3">
        <div class="product-img"  @click="viewProduct(product)">
           <img :src="product.product_image[0]" alt="#" @click="viewProduct(product)">
          <!--   <div class="product-badge" v-if="product.sale_tag">
                <ul>
                    <li class="sale-badge" >{{ product.sale_tag }}</li>
                </ul>
            </div> -->
        </div>
        <div class="product-info">
            
             <h2 class="product-title" @click="viewProduct(product)">{{ product.product_name }}</h2>
            <div class="product-ratting">
            </div>
            <div class="product-price">
                <span>
                  {{ getProductPrice(product) | currencyFormat }} </span>
                <del  v-if="getProductSlashedPrice(product) > 0">
                <span >{{ getProductSlashedPrice(product) | currencyFormat }}</span>
                </del>
            </div>
            <div class="product-brief">
                <!-- <small>{{ product.product_description }}</small> -->
            </div>
            <div class="promo-details" v-if="hasProductPromo(product)">
               <small v-for="promo of product.promo">{{  promo.promo_description }}<br></small>
             </div>
             <div class="product-hover-action">
                <ul>
                    <li>
                        <a @click="quickview(product)" title="Quick View">
                            <i class="far fa-eye"></i>
                        </a>
                    </li>
                    <li>
                        <a @click="addToCart(product, 1)" title="Add to Cart">
                            <i class="fas fa-shopping-cart"></i>
                        </a>
                    </li>
                 <!--    <li>
                        <a @click="addToWishlist(product, 1)" title="Wishlist">
                            <i class="far fa-heart"></i></a>
                    </li> -->
                </ul>
            </div>
        </div>
    </div>
    
  <AddToCartDialogue ref="addToCartDialogue" />
    <QuickviewModal :product="product" v-if="showQuickview" @addToCart="quickviewAddToCart" @addToWishlist="quickvieWishlist" @onClose="showQuickview = false" />
    <AddToCartModal :product="product" :status="modal_status" :message="modal_custom_message" v-if="showAddToCart"  @onClose="showAddToCart = false" />
    <WishlistModal :product="product" v-if="showAddToWishlist" @onClose="showAddToWishlist = false" />
    </div>
</template>
<style scoped>
.product-img {
  
    display: flex;
    justify-content: center;
    align-items: center;
    /* background: white; */
}
.product-price {
    text-align: center;
}
.product-title
{
  text-align:center;
}

</style>


// WEBPACK FOOTER //
// src/components/shared/ProductCard.vue